import {StyledChip} from './CustomChipStyles'
import PropTypes from 'prop-types'

const CustomChipIndex = ({chipData}) => {
  return (
    <>
      {chipData?.map((data) => {
        return <StyledChip label={data.name} key={`${data.id}-${data.category}`} />
      })}
    </>
  )
}

CustomChipIndex.propTypes = {
  chipData: PropTypes.array
}

export default CustomChipIndex
